<template>
  <div class="widget-imageText">
<!--    <menu-title :close="close">{{ targetTitle }}</menu-title>-->
    <menu-item class="mt-16px" :label="$t('menu.image')">
      <menuBackgroundImage :target="target"  :eye-key="'backgroundImageShow'"></menuBackgroundImage>
    </menu-item>

    <menu-item class="url mt-4" :label="$t('menu.link')">
      <base-input v-model="target.url" :value="target.url" @change="name=>change(target.url, 'url')" />
    </menu-item>

    <menu-item :border-bottom="false" class="menu-item-switch" :label="$t('menu.layout')">
      <div class="switchs">
        <menu-switch :value="target.titleShow" :label="$t('menu.itemTitle')" @change="e=> target.titleShow = e"></menu-switch>
      </div>
       <div class="switchs">
        <menu-switch :value="target.descriptionShow" :label="$t('menu.describe')" @change="e=> target.descriptionShow = e"></menu-switch>
      </div>
    </menu-item>
    <DeleteBlockDialogTrigger @delete-block="deleteBlock">
    </DeleteBlockDialogTrigger>
  </div>
</template>

<script>
// 属性编辑
import { ImageTextItemWidgetModel } from '~/site/model/models/imageTextItem'
import MenuItem from '~/components/menu/menuItem'
import MenuSwitch from '~/components/menu/menuSwitch'
// import menuTitle from '~/components/menu/menuTitle'
import BaseInput from '~/components/base/baseInput'
import menuBackgroundImage from '~/components/menu/menuBackgroundImage.vue'
import DeleteBlockDialogTrigger from '~/site/components/editMenu/deleteBlockTrigger'

export default {
  name: 'ImageTextItemWidget',
  components: {
    MenuItem,
    MenuSwitch,
    // menuTitle,
    BaseInput,
    menuBackgroundImage,
    DeleteBlockDialogTrigger,
  },
  props: {
    childIndex: {
      type: [Number, undefined],
      default() {
        return undefined
      },
    },
    model: {
      type: [Object, undefined],
      default() {
        return undefined
      },
    },
    target: {
      type: Object,
      default() {
        return new ImageTextItemWidgetModel()
      },
    },
    editing: {
      type: Boolean,
      default: false,
    },
    site: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    targetTitle() {
      return `${this.$t('model.imageTextItem')}${
        this.childIndex === undefined ? '' : this.childIndex + 1
      }`
    },
  },
  methods: {
    deleteBlock() {
      const child = this.model?.children
      if (child) {
        const findIndex = child.findIndex((c) => c === this.target)
        if (findIndex >= 0) {
          child.splice(findIndex, 1)
        }
      }
      this.$emit('delete-block', this.target)
      this.close()
    },
    close() {
      this.SiteMenu.close()
    },
    openThreeMenu(key, target) {
      this.SiteMenu.open({
        key,
        target,
        model: this.model
      })
    },
    openSubMenu(key, target) {
      this.SiteMenu.open({
        key,
        target,
        model: this.model
      })
    },
    change() {},
  },
}
</script>
